import 'dayjs/locale/vi'

import RenderRouter from '@/routers/RenderRouter'
import { useEffect, useState } from 'react'
import Cookies from 'universal-cookie'
import authApiRequest from './apis/auth.api'
import './App.css'
import { ROUTES } from './constants/routesConstants'
import './global.scss'
import { onGetPermissions, onGetUserInfo, selectPermissions } from './reducers/authentication'
import { useAppDispatch } from './state/hooks'
import { getToken, removeItem, setItem } from './utils/indexDB'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { Button, Loading, Modal } from '@greenglobal/greencore.fe.common'
import AutoLogout from './components/CommonComponents/AutoLogout'
import Text from './components/CommonComponents/Text'

const cookies = new Cookies()

function App() {
  const dispatch = useAppDispatch()
  const searchParams = new URLSearchParams(window.location.search)
  const access_token = searchParams.get('access_token') || getToken()
  const application_id = searchParams.get('application_id') || cookies.get('application_id')
  const user_id = searchParams.get('user_id') || cookies.get('user_id')
  const permissions = useSelector(selectPermissions)
  const [isShowPopupExpired, setIsShowPopupExpired] = useState(false)

  const resetCookies = () => {
    cookies.remove('application_id')
    cookies.remove('user_id')
    removeItem()
  }

  const handleSessionExpired = () => {
    setIsShowPopupExpired(true)
    resetCookies()
  }

  const handleLogout = () => {
    setIsShowPopupExpired(false)
    resetCookies()
    window.location.replace(`${process.env.REACT_APP_DOMAIN_QTUD_URL_API}${ROUTES.TRANG_CHU}?isLogout=true`)
  }

  const getMe = async (access_token: string) => {
    try {
      const response = await authApiRequest.me(access_token)
      dispatch(onGetUserInfo(response.data.data))
    } catch (error) {
      console.log('getMe ~ error:', error)
    }
  }

  const getPermissions = async (application_id: number, user_id: number) => {
    try {
      const response = await authApiRequest.getPermissionFollowUser(application_id, user_id)
      dispatch(onGetPermissions(response?.data?.data?.map((item: { code: string }) => item?.code)))
    } catch (error) {
      console.log('getMe ~ error:', error)
    }
  }

  useEffect(() => {
    if (access_token) {
      if (!getToken()) {
        setItem(access_token)
      }

      getMe(access_token)

      const newUrl = location.pathname
      window.history.replaceState(null, '', newUrl)
    } else {
      if (!isShowPopupExpired) {
        window.location.replace(`${process.env.REACT_APP_DOMAIN_QTUD_URL_API}${ROUTES.LOGIN}`)
      }
    }
  }, [access_token, location.pathname])

  useEffect(() => {
    if (application_id && user_id) {
      if (!cookies.get('application_id')) {
        cookies.set('application_id', application_id, { secure: true })
      }
      if (!cookies.get('user_id')) {
        cookies.set('user_id', user_id, { secure: true })
      }
      getPermissions(Number(application_id), Number(user_id))
    }
  }, [application_id, user_id])
  return (
    <>
      {access_token && !isEmpty(permissions) ? <RenderRouter /> : <Loading type='INDICATOR' />}
      <AutoLogout
        callback={handleSessionExpired}
        timeout={process.env.REACT_APP_EXPIRED_SESSION ? Number(process.env.REACT_APP_EXPIRED_SESSION) : 300000}
      />
      <Modal
        width={450}
        centered
        open={isShowPopupExpired}
        title={<div style={{ textTransform: 'uppercase', fontWeight: 700, fontSize: 16 }}>Phiên đã hết hạn</div>}
        classNames={{ content: 'content-modal-expired' }}
        footer={
          <Button type='primary' onClick={handleLogout}>
            <Text size='14' content='Đồng ý' color='--white' />
          </Button>
        }
      >
        <div style={{ padding: '0' }}>Vui lòng đăng nhập lại</div>
      </Modal>
    </>
  )
}

export default App
